import SessionHistory from './SessionHistory'
export default SessionHistory

import reducer, { setParentLocation, clearParentLocation } from './reducks'
import { getPreviousLocation, getPreviousHref, getPreviousTopLevelLocation, getPreviousTopLevelHref } from './selectors'
export {
  reducer,
  setParentLocation,
  clearParentLocation,
  getPreviousLocation,
  getPreviousHref,
  getPreviousTopLevelLocation,
  getPreviousTopLevelHref,
}
